import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// Temporary helper to get normalized filters
export var getNormalizedFilters = filters => {
  return _objectSpread(_objectSpread({
    categoryIds: []
  }, filters), {}, {
    aggregationFilter: _objectSpread(_objectSpread({}, filters.aggregations.reduce((filters, filterField) => {
      filters[filterField.field] = [];
      return filters;
    }, {})), filters.aggregationFilter)
  });
};
export var getNormalizedFiltersCustomFilters = (filterSettings, initialFilters) => {
  return _objectSpread({
    categoryIds: []
  }, filterSettings.reduce((filters, _ref) => {
    var getDefaultValue = _ref.getDefaultValue,
        field = _ref.field;

    if (getDefaultValue) {
      filters = getDefaultValue({
        filters
      });
    } else {
      filters.aggregationFilter[field] = filters.aggregationFilter[field] || [];
    }

    return filters;
  }, // Make sure that we can still look for our fields if `initialFilters`
  // doesn't have an `aggregationFilter`.
  _objectSpread({
    aggregationFilter: {}
  }, initialFilters)));
};
export var openCustomFilterDrawers = (toggleCollapsibleFilterIsOpen, filterSettings) => {
  var toggleFilters = [...filterSettings.map(filter => filter.field)]; // size filter is not always present as 'size', but we need to open it as well

  if (!toggleFilters.includes('size')) {
    toggleFilters.push('size');
  }

  toggleCollapsibleFilterIsOpen({
    type: 'open_all',
    filterFields: toggleFilters
  });
};